import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IPaginated, IRoom } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'rooms'

const getAll = (axios: ReturnType<typeof useAxios>) => (firmId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
  })
}

const create = (axios: IFactoryFunctionRequest<IRoom, Partial<IRoom>>) => (data: Partial<IRoom>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<IRoom, Partial<IRoom>>) => (roomId: string, data: Partial<IRoom>) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${roomId}`,
    data,
  })
}

type TPaginatedResponse = Array< '_id' | 'display'>
const filter = (axios: IFactoryFunctionRequest<IPaginated<TPaginatedResponse>, any>) => ({
  page = 0,
  search = '',
  limit = 30,
}: { page?: number; search?: string; limit?: number }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: { page, search, limit },
  })
}
type TSuperAdminRoomListResponse = {
  docs: Array<IRoom>
  count: {
    total: number
    totalPages: number
    currentPage: number
    hasNextPage: boolean
  }
}

const superAdminList = (axios: IFactoryFunctionRequest<TSuperAdminRoomListResponse, undefined>) => ({
  page = 0,
  search = '',
  limit = 30,
  roomId,
}: { page?: number; search?: string; limit?: number; roomId?: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/superAdminList`,
    query: { page, search, limit, roomId },
  })
}

const superAdminCreate = (axios: IFactoryFunctionRequest<{ _id: string }, Partial<IRoom>>) => (data: Partial<IRoom>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/superAdmin`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  create: create(useAxios(axios)),
  filter: filter(useAxios(axios)),
  superAdminList: superAdminList(useAxios(axios)),
  superAdminCreate: superAdminCreate(useAxios(axios)),
  update: update(useAxios(axios)),
})
